
import React from 'react';

const services = [
  {
    number: '01',
    title: 'Executive Systems Architecture',
    description:
      'We design infrastructure that aligns compliance, operations, marketing, and revenue into one unified performance model.',
    image:
      'https://public.readdy.ai/ai/img_res/96b01eed4afd1fec459a0b8105c24d65.jpg',
  },
  {
    number: '02',
    title: 'Revenue & Growth Optimization',
    description:
      'We implement automation and data frameworks that improve lead quality, conversion efficiency, and financial visibility.',
    image:
      'https://readdy.ai/api/search-image?query=upward%20trending%20data%20analytics%20dashboard%20visualization%20with%20glowing%20charts%20and%20metrics%20in%20dark%20navy%20background%20with%20teal%20accent%20highlights%20modern%20business%20intelligence%20concept%20clean%20minimal&width=600&height=400&seq=svc002&orientation=landscape',
  },
  {
    number: '03',
    title: 'Governance & Risk Alignment',
    description:
      'Every system is built to support regulatory standards, audit readiness, and executive oversight.',
    image:
      'https://readdy.ai/api/search-image?query=secure%20digital%20shield%20and%20lock%20concept%20with%20geometric%20patterns%20representing%20cybersecurity%20and%20compliance%20in%20dark%20navy%20and%20teal%20color%20scheme%20modern%20corporate%20governance%20technology%20minimal%20clean&width=600&height=400&seq=svc003&orientation=landscape',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="bg-white py-32">
      <div className="max-w-[1280px] mx-auto px-8 lg:px-20">
        <h2 className="text-[44px] font-semibold text-[#0B1F3A] text-center max-w-[700px] mx-auto mb-20 leading-tight">
          From operational complexity to measurable performance.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {services.map((item, index) => (
            <div key={index} className="group">
              <div className="w-full h-[200px] rounded-xl overflow-hidden mb-6">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Tailwind opacity utility uses a slash (e.g., bg-[#1EB6B0]/20). This syntax is valid inside a string. */}
              <div className="text-[48px] font-bold text-[#1EB6B0]/20 leading-none mb-3">
                {item.number}
              </div>
              <h3 className="text-[22px] font-semibold text-[#0B1F3A] leading-tight mb-4">
                {item.title}
              </h3>
              <p className="text-[15px] text-[#0B1F3A]/60 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-xl font-medium text-[#0B1F3A] text-center">
          No disconnected tools. No fragile automation. Structured systems built to scale.
        </p>
      </div>
    </section>
  );
}
